import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconMoodSadDizzy(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
			<path d="M14.5 16.05a3.5 3.5 0 0 0 -5 0" />
			<path d="M8 9l2 2" />
			<path d="M10 9l-2 2" />
			<path d="M14 9l2 2" />
			<path d="M16 9l-2 2" />
		</Icon>
	);
}
